export const trackedItemCardGraphOptions = () => ({
	title: { display: false },
	legend: { display: false },
	tooltips: { callbacks: {} },
	responsive: true,
	maintainAspectRatio: false,
	scales: {
		xAxes: [
			{
				gridLines: { color: "rgba(0, 0, 0, 0)" },
				stacked: false,
				ticks: { fontFamily: "Nunito Sans" },
			},
		],
		yAxes: [
			{
				ticks: {
					beginAtZero: true,
					maxTicksLimit: 6,
					fontFamily: "Nunito Sans",
				},
				stacked: false,
			},
		],
	},
});
